<template>
	<div class="about">
		<div class="pg-header">
			<div>
				<label class="title">问卷详情</label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>统计管理</span>|
					<span>问卷统计</span>|
					<span>问卷详情</span>
				</div>
			</div>
		</div>

		<div class="collapse-wrap">
			<div class="search-bar">
				<el-form ref="form" label-width="120px">
					<div class="def-key">
						<div style="display: inline-block;">问卷名称
							<el-select size="small" filterable clearable v-model="filter.dictId" placeholder="请选择"
								@change="handleFilter(1, $event)">
								<el-option v-for="item in questList" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</div>
						<label>填写日期
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px"
								type="daterange" align="right" unlink-panels range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.finishdate"
								:picker-options="pickerOptions" @change="handleFilter(3, $event)"></el-date-picker>
						</label>
						<label>{{ timeLabel[dataSources] }}
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px"
								type="daterange" align="right" unlink-panels range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.date"
								:picker-options="pickerOptions" @change="handleFilter(0, $event)"></el-date-picker>
						</label>
						<div style="display: inline-block;">科室
							<el-select size="small" filterable clearable v-model="filter.depId" placeholder="请选择"
								@change="handleFilter(1, $event)">
								<el-option v-for="item in deptList" :key="item.id" :label="item.name"
									:value="Number(item.id)"></el-option>
							</el-select>
						</div>
						<div style="display: inline-block;">机构
							<el-select size="small" filterable clearable v-model="filter.orgId" placeholder="请选择"
								@change="handleFilter(1, $event)">
								<el-option v-for="item in orgList" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</div>
						<el-button size="mini" icon="el-icon-search" round
							@click="handleFilter(4, $event)">搜索</el-button>
						<el-button class="btn-export flr" size="mini" round @click="exportExcel"><i class="icon-export"
								style="margin-right: 10px;"></i>导出</el-button>
					</div>
				</el-form>
			</div>

			<div class="table-wrap">
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
					:data="list.data" v-loading="isLoading">
					<el-table-column label="姓名" width="180">
						<template slot-scope="scope">{{ scope.row.name }}</template>
					</el-table-column>
					<el-table-column label="身份证号码" width="180" v-if="hospitalCode == 'FJ_YX1'">
						<template slot-scope="scope">{{ scope.row.cardNumberHide }}</template>
					</el-table-column>
					<el-table-column label="住院号" width="180">
						<template slot-scope="scope">{{ scope.row.admissionNumber }}</template>
					</el-table-column>
					<el-table-column label="科室" width="180">
						<template slot-scope="scope">{{ scope.row.depName }}</template>
					</el-table-column>
					<el-table-column label="诊断" width="180">
						<template slot-scope="scope">{{ scope.row.diagnosisName }}</template>
					</el-table-column>
					<el-table-column :label="timeLabel[dataSources]" width="180">
						<template slot-scope="scope">{{ scope.row.hospitalDate }}</template>
					</el-table-column>
					<el-table-column label="填写人" width="180">
						<template slot-scope="scope">{{ scope.row.userName }}</template>
					</el-table-column>
					<el-table-column label="填写时间" width="180">
						<template slot-scope="scope">{{ scope.row.finishTime }}</template>
					</el-table-column>
					<el-table-column v-for="item in questionInfo.formItems" :label="item.label" :key="item.formId"
						width="180" show-overflow-tooltip>
						<template slot-scope="scope">{{ scope.row[item.formId] }}</template>
						<!-- <template>{{ item.formId }}</template> -->
						<!-- <el-table-column v-for="option in item.options" :label="option.label" :key="option.value"></el-table-column> -->
					</el-table-column>
					<template #empty>
						<div style="text-align: center;">
							<p style="font-size:16px;color:#699CE4;">暂无数据，请【选择问卷】后进行查看</p>
						</div>
					</template>
				</el-table>
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span
									v-text="(filter.pageNumber - 1) * filter.pageSize + 1"></span>条至第<span
									v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据
							</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next"
								:page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" prev-text="上一页" next-text="下一页"
								:current-page="list.current" :page-size="filter.pageSize" :total="list.total"
								@size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>
			</div>
			<div style="display: none;">
				<el-table ref="multipleTable2" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
					:data="list2.data" v-loading="isLoading">
					<el-table-column label="姓名" width="180">
						<template slot-scope="scope">{{ scope.row.name }}</template>
					</el-table-column>
					<el-table-column label="身份证号码" width="180" v-if="hospitalCode == 'FJ_YX1'">
						<template slot-scope="scope">{{ scope.row.cardNumber }}</template>
					</el-table-column>
					<el-table-column label="住院号" width="180">
						<template slot-scope="scope">{{ scope.row.admissionNumber }}</template>
					</el-table-column>
					<el-table-column label="科室" width="180">
						<template slot-scope="scope">{{ scope.row.depName }}</template>
					</el-table-column>
					<el-table-column label="诊断" width="180">
						<template slot-scope="scope">{{ scope.row.diagnosisName }}</template>
					</el-table-column>
					<el-table-column :label="timeLabel[dataSources]" width="180">
						<template slot-scope="scope">{{ scope.row.hospitalDate }}</template>
					</el-table-column>
					<el-table-column label="填写人" width="180">
						<template slot-scope="scope">{{ scope.row.userName }}</template>
					</el-table-column>
					<el-table-column label="填写时间" width="180">
						<template slot-scope="scope">{{ scope.row.finishTime }}</template>
					</el-table-column>
					<el-table-column v-for="item in questionInfo.formItems" :label="item.label" :key="item.formId"
						width="180" show-overflow-tooltip>
						<template slot-scope="scope">{{ scope.row[item.formId] }}</template>
						<!-- <template>{{ item.formId }}</template> -->
						<!-- <el-table-column v-for="option in item.options" :label="option.label" :key="option.value"></el-table-column> -->
					</el-table-column>
					
				</el-table>
			</div>
		</div>

	</div>
</template>

<script>
import api from '@/service/api.js';
import mixin from '@/views/mixin';
import dayjs from 'dayjs';
import utils from '@/service/utils.js';

export default {
	mixins: [mixin],
	data() {
		return {
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			filter: {
				hospitalTimeStart: '',
				hospitalTimeEnd: '',
				depId: '',
				orgId: '',
				pageNumber: 1,
				pageSize: 10,
				dictId: '',
				finishdate: [],
				date: [],
				finishTimeStart: '',
				finishTimeEnd: ''
			},
			deptList: [],
			questionInfo: {},
			permission: false,
			orgList: [],
			list2: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			hospitalCode: '',
			dataSources: 2,
			timeLabel: {
				0: '入院日期',
				1: '就诊日期',
				2: '出院日期'
			},
			questList: []
		}
	},
	watch: {
		'$route.query': {
			handler(newQuery, oldQuery) {
				if (!oldQuery) return;

				const keyParams = ['dictId', 'datasources', 'depId'];

				const finishdateChanged = JSON.stringify(newQuery.finishdate) !== JSON.stringify(oldQuery.finishdate);
				const dateChanged = JSON.stringify(newQuery.date) !== JSON.stringify(oldQuery.date);
				const hasKeyChange = keyParams.some(key => newQuery[key] !== oldQuery[key]) || finishdateChanged || dateChanged;
				if (hasKeyChange) {
					this.initializeFromQuery(newQuery);
					this.loadList();
				}
			},
			immediate: false
		}
	},

	async created() {
		await this.loadInitialData();
		
		this.$nextTick(() => {
			this.initializeFromQuery(this.$route.query);

			this.$forceUpdate();
			this.loadList();

		});
		
	},
	methods: {
		initializeFromQuery(query) {
			this.filter.dictId = query.dictId ? +query.dictId : '';
			this.filter.depId = query.depId ? +query.depId : '';  
			this.dataSources = query.datasources !== undefined ? +query.datasources : 2;
			if (!query.finishdate && !query.date&&!query.dictId) {
				this.setTime();
			}else if(query.finishdate || query.date){
				this.handleDateParams(query);

			}


		},
		handleDateParams(query) {
			// 处理填写日期参数
			if (query.finishdate) {
				const dates = query.finishdate.split(',');
				if (dates.length === 2) {
					this.filter.finishTimeStart = dayjs(dates[0].trim()).format('YYYY-MM-DD 00:00:00');
					this.filter.finishTimeEnd = dayjs(dates[1].trim()).format('YYYY-MM-DD 23:59:59');
					this.filter.finishdate = [
						new Date(dates[0].trim()),
						new Date(dates[1].trim())
					];
				}
			}

			// 处理出院日期参数
			if (query.date) {
				const dates = query.date.split(',');
				if (dates.length === 2) {
					this.filter.hospitalTimeStart = dayjs(dates[0].trim()).format('YYYY-MM-DD 00:00:00');
					this.filter.hospitalTimeEnd = dayjs(dates[1].trim()).format('YYYY-MM-DD 23:59:59');
					this.filter.date = [
						new Date(dates[0].trim()),
						new Date(dates[1].trim())
					];
				}
			}
		},
		// 重置过滤器
		resetFilter(query) {
			this.filter = {
				hospitalTimeStart: '',
				hospitalTimeEnd: '',
				depId: query.depId ? +query.depId : '', 
				orgId: '',
				pageNumber: 1,
				pageSize: 10,
				dictId: query.dictId ? +query.dictId : '',
				finishdate: [],
				date: [],
				finishTimeStart: '',
				finishTimeEnd: ''
			};
		},

		setTime() {
			const now = dayjs();
			const firstDayOfMonth = dayjs().startOf('month');
			this.filter.finishTimeStart = firstDayOfMonth.format('YYYY-MM-DD HH:mm:ss');
			this.filter.finishTimeEnd = now.format('YYYY-MM-DD HH:mm:ss');
			this.filter.finishdate = [this.filter.finishTimeStart, this.filter.finishTimeEnd];
		},

		async loadInitialData() {
			try {
				const [deptRes, orgRes, hospitalCode, questRes] = await Promise.all([
					api.getDeptDropdown(),
					api.getListComboboxOrg(),
					api.getHospitalCode(),
					api.getComboboxQuestionnaire()

				]);

				if (deptRes.code === 1000 && deptRes.data) {
					this.deptList = deptRes.data;
				}
				if (questRes.code === 1000) {
					this.questList = questRes.data;
				}
				if (orgRes.code === 1000) {
					this.orgList = orgRes.data;
				} else {
					this.$message.error(orgRes.message);
				}

				this.hospitalCode = hospitalCode;

			} catch (error) {
				console.error('加载初始数据失败:', error);
				this.$message.error('加载初始数据失败');
			}
		},

		async loadList() {
			if (!this.filter.dictId) {
				this.list = {
					total: 0,
					current: 1,
					pageSize: 0,
					data: []
				};
				return;
			}
			this.isLoading = true;
			let res = await api.getQuestionnaireDetail(this.filter);
			if (res.code == 500) { return this.$router.push({ name: 'Login', query: { r: location.href } }); }
			if (res.code == 1000) {

				this.list.total = +res.total;
				this.list.current = this.filter.pageNumber;
				this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
				this.list.data = res.data?.formResults;
				this.list.data.forEach((item) => {
					item.cardNumberHide = utils.hideIdCard(item.cardNumber);
				})
				this.questionInfo = res.data;
			} else {
				this.list.data=[]
				this.$message.error(res.message)
			}
			// 权限控制
			this.user = JSON.parse(localStorage.getItem('user')).data;
			this.permission = (this.user.user.roleId == "6" || this.user.user.roleId == "1" || this.user.user.roleId == "9") ? true : false;
			this.isLoading = false;
		},
		getSummaries() {
			this.$nextTick(() => {
				this.$refs['multipleTable'].doLayout();
				this.$refs['multipleTable2'].doLayout();
			});
			return this.list.summary;
		},
		// 过滤条件 更改
		handleFilter(key, val) {
			switch (key) {
				case 0:
					if (this.filter.date) {
						this.filter.hospitalTimeStart = dayjs(this.filter.date[0]).format('YYYY-MM-DD 00:00:00');
						this.filter.hospitalTimeEnd = dayjs(this.filter.date[1]).format('YYYY-MM-DD 23:59:59');
					} else {
						this.filter.hospitalTimeStart = '';
						this.filter.hospitalTimeEnd = '';
					}
					break;
				case 3:
					if (this.filter.finishdate) {
						this.filter.finishTimeStart = dayjs(this.filter.finishdate[0]).format('YYYY-MM-DD 00:00:00');
						this.filter.finishTimeEnd = dayjs(this.filter.finishdate[1]).format('YYYY-MM-DD 23:59:59');
					} else {
						this.filter.finishTimeStart = '';
						this.filter.finishTimeEnd = '';
					}
					break;
			}
			this.filter.pageNumber = 1;
			if (val || key == 4) {
				this.loadList();
			}
		},
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		},
		exportExcel() {
			let outdate = "";
			this.loadList2()
			// 导出excel
			if (this.filter.date) {
				outdate = " 出院日期：" + dayjs(this.filter.date[0]).format('YYYY-MM-DD') + "~" + dayjs(this.filter.date[1]).format('YYYY-MM-DD')
			}
			utils.exportExcel(this.$refs.multipleTable2, 'sheet1', "《" + this.questionInfo.dictName + "》详情" + outdate + ".xlsx");
		},
		async loadList2() {
			this.filter.pageSize = this.list.total
			let res = await api.getQuestionnaireDetail(this.filter);
			if (res.code == 500) { return this.$router.push({ name: 'Login', query: { r: location.href } }); }
			this.list2.total = +res.total;
			this.list2.current = this.filter.pageNumber;
			this.list2.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			this.list2.data = res.data.formResults;
			this.questionInfo = res.data;
			// // 权限控制
			// this.user = JSON.parse(localStorage.getItem('user')).data;
			// this.permission = (this.user.user.roleId == "6" || this.user.user.roleId == "1") ? true : false;
			this.isLoading = false;
		},
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';
</style>
